import axios from 'axios';
import { validateToken } from './validateToken';

// Create an Axios instance
const api = axios.create({
    baseURL: 'https://payments.leviton.com/api',
});

// List of routes to skip auth check


// Add a request interceptor to validate the token before each request
api.interceptors.request.use(
    async (config) => {
        // Check if the request URL matches any of the routes to skip auth
        if (config.url.startsWith('/get-authorize-net-data')) {
            return config; // Skip auth check
        }

        const token = localStorage.getItem('authToken');

        // Validate the token using the utility function
        const isValid = await validateToken(token);

        if (isValid) {
            // Attach the token to the request headers if valid
            config.headers['Authorization'] = `Bearer ${token}`;
            return config;
        } else {
            // Handle token expiration or invalidation
            localStorage.removeItem('authToken');
            window.location.href = '/login'; // Redirect to login page
            return Promise.reject(new Error('Token is invalid or expired'));
        }
    },
    (error) => {
        // Handle request errors
        return Promise.reject(error);
    }
);

export default api;
